<template>
  <v-row>
    <v-col cols="12">
      <v-card class="mt-5" color="primary" elevation="0">
        <v-card-title class="pb-0">
          <p class="h4 font-general-r color-blue">
            HISTORIAL DE PAGOS DE TU SUSCRIPCIÓN
          </p>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="() => $emit('closePayments')"
          >
            <v-icon color="accent">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="payments.length" class="table-responsive-sm">
            <table class="table">
              <thead>
                <tr>
                  <th class="color-blue font-general-r">FECHA</th>
                  <th class="color-blue font-general-r">TOTAL</th>
                  <th class="color-blue font-general-r">ESTADO DE PAGO</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="payment of payments" :key="payment.id">
                  <td class="td-nv">
                    <p class="h5 mt-2">
                      {{ formatDate(payment.created_at, 'D MMMM YYYY') }}
                    </p>
                  </td>
                  <td class="td-nv">
                    <p class="h5 mt-2">
                      {{ currencyFormat(payment.total) }}
                    </p>
                  </td>
                  <td class="td-nv">
                    <p class="h5 mt-2">
                      {{ payment.status ? 'PAGADO' : 'FALLIDO' }}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p v-else class="h3 text-center font-general-r color-blue">
            No tienes pagos
          </p>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'
moment.locale('es')
import { currencyFormat } from '@/helpers'

export default {
  props: ['payments'],
  methods: {
    formatDate(date, format) {
			return moment(date).format(format)
		},
    currencyFormat(price) {
			return currencyFormat(price)
    }
  }
}
</script>

<style scoped>
  table {
    border-collapse: collapse;
  }
  th, tr {
    border: none !important;
  }
  .table th, .td-nv {
    font-size: 18px;
    text-align: left;
    color: var(--color-tertiary);
    font-family: var(--font-baloo-regular)
  }
  >>>.table td, .table th {
    border-top: 0 !important
  }
</style>
